import {useMemo} from "react";
import {useGetPriceRangeReportQuery} from "../store/api/priceRangeReportApi";
import type {PriceRangeReportQueryDto} from "../types/priceRangeReport";

export const usePriceRangeReport = (params: PriceRangeReportQueryDto = {}) => {
  const {data, isLoading, isFetching, error, refetch} =
    useGetPriceRangeReportQuery(params);

  // Memoized values
  const reportData = useMemo(() => data?.data || [], [data]);
  const summary = useMemo(() => data?.summary, [data]);
  const metadata = useMemo(() => data?.metadata, [data]);

  return {
    // Data
    reportData,
    summary,
    metadata,

    // Loading states
    isLoading: isLoading || isFetching,

    // Error
    error,

    // Actions
    refetch,
  };
};

export default usePriceRangeReport;
// Export types for component usage
